import { render } from "./ForgotPasswordView.vue?vue&type=template&id=3fa780e7&ts=true"
import script from "./ForgotPasswordView.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__